import {
  AUDIT_LABEL_FETCHING,
  AUDIT_LABEL_FAILED,
  AUDIT_LABEL_DONE,
  PRODUCT_FAILURE_DETAILS_FETCHING,
  PRODUCT_FAILURE_DETAILS_FAILED,
  PRODUCT_FAILURE_DETAILS_DONE,
  AUDIT_RULES_FETCHING,
  AUDIT_RULES_FAILED,
  AUDIT_RULES_DONE,
  FEED_WITH_FAILURES_PROGRESS_FETCHING,
  FEED_WITH_FAILURES_PROGRESS_DONE,
  FEED_WITH_FAILURES_PROGRESS_FAILED,
  GENERATE_FEED_WITH_FAILURES_FETCHING,
  GENERATE_FEED_WITH_FAILURES_DONE,
  GENERATE_FEED_WITH_FAILURES_FAILED,
} from './actions'
import { APP_STATE } from '../../../constants'

export const initialState = {
  // Audit label
  auditLabelState: null,
  auditLabelData: '',
  auditLabelError: null,

  // List productFailureDetails
  productFailureDetailsState: null,
  productFailureDetailsData: [],
  productFailureDetailsError: null,
  pageTotal: null,
  page: null,

  // Audit rules
  auditRulesState: null,
  auditRulesData: [],
  auditRulesError: null,

  // Check the progress of feed with product failures file
  feedWithFailuresProgressState: null,
  feedWithFailuresProgressData: null,
  feedWithFailuresProgressError: null,

  // Sending service bus message to generate feed with failures file
  generateFeedWithFailuresState: null,
  generateFeedWithFailuresError: null,
}

export const reducer = (state, action) => {
  switch (action.type) {
    // Audit label
    case AUDIT_LABEL_FETCHING:
      return {
        ...state,
        auditLabelState: APP_STATE.FETCHING,
      }

    case AUDIT_LABEL_FAILED:
      return {
        ...state,
        auditLabelState: APP_STATE.ERROR,
        auditLabelData: '',
        auditLabelError: action.message,
      }

    case AUDIT_LABEL_DONE:
      return {
        ...state,
        auditLabelState: APP_STATE.DONE,
        auditLabelData: action.auditLabel,
      }

    // List productFailureDetails
    case PRODUCT_FAILURE_DETAILS_FETCHING:
      return {
        ...state,
        productFailureDetailsState: APP_STATE.FETCHING,
      }

    case PRODUCT_FAILURE_DETAILS_FAILED:
      return {
        ...state,
        productFailureDetailsState: APP_STATE.ERROR,
        productFailureDetailsData: [],
        productFailureDetailsError: action.message,
      }

    case PRODUCT_FAILURE_DETAILS_DONE:
      return {
        ...state,
        productFailureDetailsState: APP_STATE.DONE,
        productFailureDetailsData: action.productFailureDetails,
        pageTotal: action.pageTotal,
        page: action.page,
      }

    // Rules
    case AUDIT_RULES_FETCHING:
      return {
        ...state,
        auditRulesState: APP_STATE.FETCHING,
      }

    case AUDIT_RULES_FAILED:
      return {
        ...state,
        auditRulesState: APP_STATE.ERROR,
        auditRulesData: [],
        auditRulesError: action.message,
      }

    case AUDIT_RULES_DONE:
      return {
        ...state,
        auditRulesState: APP_STATE.DONE,
        auditRulesData: action.auditRules,
      }

    // Product failure details feed file progress
    case FEED_WITH_FAILURES_PROGRESS_FETCHING:
      return {
        ...state,
        feedWithFailuresProgressState: APP_STATE.FETCHING,
      }
    case FEED_WITH_FAILURES_PROGRESS_DONE:
      return {
        ...state,
        feedWithFailuresProgressState: APP_STATE.DONE,
        feedWithFailuresProgressData: action.progress,
      }
    case FEED_WITH_FAILURES_PROGRESS_FAILED:
      return {
        ...state,
        feedWithFailuresProgressState: APP_STATE.ERROR,
        feedWithFailuresProgressError: action.message,
      }

    // Request to generate product failure details feed file
    case GENERATE_FEED_WITH_FAILURES_FETCHING:
      return {
        ...state,
        generateFeedWithFailuresState: APP_STATE.FETCHING,
      }
    case GENERATE_FEED_WITH_FAILURES_DONE:
      return {
        ...state,
        generateFeedWithFailuresState: APP_STATE.DONE,
      }
    case GENERATE_FEED_WITH_FAILURES_FAILED:
      return {
        ...state,
        generateFeedWithFailuresState: APP_STATE.ERROR,
        generateFeedWithFailuresError: action.message,
      }

    default:
      return state
  }
}
